export const PluginConnect = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.29232 5.20817H5.62565C4.70518 5.20817 3.95898 5.95436 3.95898 6.87484V11.8748C3.95898 13.7158 5.45137 15.2082 7.29232 15.2082H10.0007M7.29232 5.20817V2.2915M7.29232 5.20817H12.709M12.709 5.20817H14.3757C15.2961 5.20817 16.0423 5.95436 16.0423 6.87484V11.8748C16.0423 13.7158 14.5499 15.2082 12.709 15.2082H10.0007M12.709 5.20817V2.2915M10.0007 15.2082V17.7082"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default PluginConnect
